import api from "@/lib/api";
import { toast } from "sonner";

export async function startCheckout(packageId, email = "", addons = []) {
  try {
    const { data } = await api.post("/payments/checkout", {
      package_id: packageId,
      origin_url: window.location.origin,
      customer_email: email,
      addons,
    });
    if (data.checkout_url) {
      window.location.href = data.checkout_url;
    }
  } catch (e) {
    const msg = e.response?.data?.detail || "Unable to start checkout. Please try again.";
    toast.error(typeof msg === "string" ? msg : "Unable to start checkout.");
  }
}
